// import Swiper core and required modules
import {Autoplay, Pagination} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import React from "react";
// Import Swiper styles
import 'swiper/swiper.min.css';
import 'swiper/modules/free-mode/free-mode.min.css';
import 'swiper/modules/navigation/navigation.scss';
import 'swiper/modules/thumbs/thumbs.min.css';
import {Card, Button, Dialog, DialogTitle, DialogContent, DialogActions, Slide, Typography, Box} from "@material-ui/core";
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {MOBILE_MAX_WIDTH} from "../../../panel/routes/data/constants";
import { BrowserView, MobileView, isBrowser, isMobile, browserName , isIOS, deviceType  } from 'react-device-detect';
import DownloadDialog from './DownloadDialog';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class GreetingSlider extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            downloadDialogOpen: false
        };
    }

    handleDownloadClick = () => {
        this.setState({ downloadDialogOpen: true });
    };

    handleCloseDownloadDialog = () => {
        this.setState({ downloadDialogOpen: false });
    };

    handleDirectDownload = () => {
        // Direct download logic here
        window.open('YOUR_DIRECT_DOWNLOAD_LINK', '_blank');
        this.handleCloseDownloadDialog();
    };

    handleBazaarDownload = () => {
        // Bazaar download logic here
        window.open('YOUR_BAZAAR_LINK', '_blank');
        this.handleCloseDownloadDialog();
    };

    render(){
        const {width} = this.props;
        const {downloadDialogOpen} = this.state;

        return(
            <>
                <Swiper
                    modules={[Pagination, Autoplay]}
                    pagination={width < MOBILE_MAX_WIDTH ? false : (true, {clickable: true})}
                    autoplay
                    className="swiper"
                >
                    {!window.matchMedia('(display-mode: standalone)').matches && width < MOBILE_MAX_WIDTH ?
                        ''
                        : ""
                    }
                    {/* <SwiperSlide>
                            <Card className="swiper-card" elevation={3}>
                                <Box p={3} textAlign="center">
                                    <div style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
                                        <div className='heading'>
                                            اپلیکیشن آی آر اکسچنجر رو اضافه کن!
                                        </div>
                                        <div className='text'>
                                            با دانلود اپلیکیشن همیشه کنارتیم
                                        </div>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="large"
                                            startIcon={<GetApp />}
                                            onClick={this.handleDownloadClick}
                                            style={{
                                                borderRadius: 25,
                                                padding: '12px 24px',
                                                fontSize: '1rem',
                                                fontWeight: 'bold',
                                                boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                                            }}
                                        >
                                            دانلود اپلیکیشن آی آر اکسچنجر
                                        </Button>
                                    </div>
                                </Box>
                            </Card>
                        </SwiperSlide> */}
                    <SwiperSlide>
                        <Card className="swiper-card" elevation={3}>
                            <Box p={3} textAlign="center">
                                <div className='heading'>
                                    آی آر اکسچنجر سامانه هوشمند تبادل ارزهای دیجیتال و الکترونیکی
                                </div>
                                <div className='text'>
                                    از سال 2013 تا به امروز با شما هستیم، با چند کلیک ساده هم‌خانواده ما شوید
                                </div>
                            </Box>
                        </Card>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Card className="swiper-card" elevation={3}>
                            <Box p={3} textAlign="center">
                                <div className='heading'>
                                    آی آر اکسچنجر مبادلات دارائی‌های دیجیتال شما را هوشمندانه پردازش و انجام می‌دهد
                                </div>
                                <div className='text'>
                                    پلتفرم خرید و فروش هوشمند، مانع از ارسال دارائی‌های رمزارزی شما به کیف پول‌های اشتباه و شبکه‌های نامتناظر می‌شود
                                </div>
                            </Box>
                        </Card>
                    </SwiperSlide>
                </Swiper>

                <DownloadDialog
                    open={downloadDialogOpen} 
                    onClose={this.handleCloseDownloadDialog}
                />
            </>
        )
    }
}

const mapStateToProps = ({settings}) => {
    const {width} = settings;
    return {width}
};
export default withRouter(connect(mapStateToProps)(GreetingSlider));